<template>
  <div class="w-full flex flex-row gap-2 rounded-md"
    :class="{
      'p-2 bg-green-200': changeType === 'add',
      'p-2 bg-red-200': changeType === 'remove',
      'p-2 bg-orange-200': changeType === 'change',
    }">
    <span class="font-bold text-green-600"
      v-if="changeType === 'add'">+</span>
    <span class="font-bold text-red-600"
      v-if="changeType === 'remove'">-</span>
    <span class="font-bold"
      v-if="changeType === 'change'">•</span>
    <slot></slot>
  </div>
</template>

<script>

export default {
  props: {
    changeType: {
      type: String,
      default: undefined,
    },
  }
}
</script>
